import { createApiSelectors } from 'reacticoon/selector'
import { formatPublicVariablesList } from './format'

export const fetchPublicVariablesListSelectors = createApiSelectors(
  'App::PublicVariables',
  formatPublicVariablesList
)